module.exports = __webpack_public_path__ + "static/chara-1a66c2f404ca80ae0cfced71f0965b6f.png";